var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5628 18.8633C12.7268 18.658 13.8389 18.2256 14.8357 17.5905C15.8325 16.9555 16.6945 16.1303 17.3724 15.1622C18.0503 14.194 18.5309 13.1018 18.7867 11.948C19.0425 10.7941 19.0685 9.60111 18.8633 8.43717C18.658 7.27322 18.2256 6.1611 17.5905 5.1643C16.9555 4.1675 16.1303 3.30554 15.1622 2.62763C14.194 1.94972 13.1018 1.46914 11.948 1.21334C10.7941 0.957527 9.60111 0.931496 8.43717 1.13673C7.27322 1.34196 6.1611 1.77444 5.1643 2.40948C4.1675 3.04451 3.30554 3.86966 2.62763 4.83781C1.94972 5.80597 1.46914 6.89816 1.21334 8.05205C0.957526 9.20593 0.931496 10.3989 1.13673 11.5628C1.34197 12.7268 1.77445 13.8389 2.40948 14.8357C3.04451 15.8325 3.86966 16.6945 4.83781 17.3724C5.80597 18.0503 6.89816 18.5309 8.05205 18.7867C9.20593 19.0425 10.3989 19.0685 11.5628 18.8633L11.5628 18.8633Z",
    stroke: "#BDBDBD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L10 15.4",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.90039L10 5.00039",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipInfo);
export default __webpack_public_path__ + "static/media/tooltipInfo.a65758c4d80846452ba72c3428a827bf.svg";
export { ForwardRef as ReactComponent };